// Per-language names for ingredient categories the customer typed themselves, stored in
// ingredients.category_labels keyed by the typed text. Ingredient rows keep that text in `category`,
// and only the displayed name is translated.
// Copied from the e-label editor's src/utils/ingredientCategoryLabels.js — change both.
// CommonJS so tests/unit/ingredient-category-labels.test.js can run it with plain node.

function isCustomCategory (name) {
  return typeof name === 'string' && !name.startsWith('ingredient_category_')
}

function canBeTranslated (name, languageKeys) {
  if (typeof name !== 'string' || !name.trim()) return false
  if (name.includes(':')) return false
  return !languageKeys.includes(name)
}

// Adds an entry for each custom category that has none, drops entries whose category is gone,
// keeps existing translations, and orders keys as the ingredient lists do.
// Returns { labels, changed }, with labels null when the map should not exist.
function rebuildCategoryLabels ({ lists, existingLabels, defaultLanguage, languageKeys }) {
  const currentLabels = existingLabels || {}
  const rebuiltLabels = {}

  lists.forEach((list) => {
    const ingredients = Array.isArray(list) ? list : []
    ingredients.forEach((ingredient) => {
      const name = ingredient ? ingredient.category : undefined
      if (typeof name !== 'string') return
      if (Object.prototype.hasOwnProperty.call(rebuiltLabels, name)) return
      if (!isCustomCategory(name) || !canBeTranslated(name, languageKeys)) return
      rebuiltLabels[name] = Object.prototype.hasOwnProperty.call(currentLabels, name)
        ? currentLabels[name]
        : { [defaultLanguage]: name }
    })
  })

  const rebuiltNames = Object.keys(rebuiltLabels)
  if (!rebuiltNames.length) {
    return { labels: null, changed: Boolean(existingLabels) }
  }
  const changed = JSON.stringify(Object.keys(currentLabels)) !== JSON.stringify(rebuiltNames)
  return { labels: rebuiltLabels, changed }
}

module.exports = { rebuildCategoryLabels }
